import { useTranslation } from 'react-i18next';
import styles from '../InterpretiveReportPage.module.css';

/** The PDF export repeats these on every page (data-pdf-header and data-pdf-footer) */
export const RunningHeader = () => {
  const { t } = useTranslation();
  return (
    <div data-pdf-header className={styles.runningHeader}>
      <img src="/trustpulse-logo.png" alt={t('interpretiveReport.document.logoAlt')} className={styles.logo} />
      <span>{t('interpretiveReport.document.header')}</span>
    </div>
  );
};

export const RunningFooter = ({ date }: { date: string }) => {
  const { t } = useTranslation();
  return (
    <div data-pdf-footer className={styles.runningFooter}>
      <span>{t('interpretiveReport.document.footer', { date })}</span>
      <span>{t('interpretiveReport.document.contact')}</span>
    </div>
  );
};
